import { Button } from '@sunwebgroup/uds-ui/button'
import cn from 'classnames'
import * as React from 'react'
import styles from './NextStepButton.module.css'

interface NextStepButtonProps {
  text: string
  form?: string
  type?: 'button' | 'submit'
  onSubmit?: () => void
  onClick?: () => void
  disabled?: boolean
  isLoading?: boolean
}

export default function NextStepButton({
  text,
  ...props
}: NextStepButtonProps) {
  return (
    <Button className={cn(styles.button)} variant="primary" {...props} data-qa="checkout-next-step-button">
      {text}
      <Button.Icon glyph="ChevronRight" />
    </Button>
  )
}
